import { createSaga } from "../../utils/createSaga";
import { hospitalRoutine } from "../routines/hospitalRoutine";

export default function* hospitalSaga() {
  yield createSaga(hospitalRoutine, "GET", "api/hospitals");
}
